export default __webpack_public_path__ + "static/andrew-headshot-7f178db6c6e822c493183ae3e8ce8e98.jpeg";